import React from 'react'
const Gap = () => (
  <div style={{ paddingTop: '10px', paddingBottom: '10px' }}></div>
)

export default Gap
